import React from 'react';
import Modal from 'jd-library/Modal';
import withPortal from 'jd-library/withPortal';
import styles from './transaction-type.scss';
import historyHandler from 'jd-library/historyHandler';

const HideUnhideModal = props => {
    const hideUnhide = () => {
        historyHandler.closeCurrent();
        props.onHideUnhide();
    }
    let action = props.action.charAt(0).toUpperCase()+props.action.slice(1);
    return (
            <Modal
                settings={{
                    modalId: 'transactiontype-modal',
                    variant: 'action',
                    class: ''
                }}
                onHidden={props.onHidden}
                backdropStatic={true}
            >
                <Modal.CloseIcon iconClass={'icon-HDRcross'} />
                <Modal.Header>{`${action} Variant ${props.isService ? 'Service' : 'Product'}`}</Modal.Header>
                <Modal.Body className={styles['body-container']}>
                    <div>
                        {`This will ${props.action} all variants of this ${props.isService ? 'service':'product'} on the webstore. Are you sure you want to ${props.action} the ${props.isService? 'service':'product'}?`}
                    </div>
                </Modal.Body>
                <Modal.CenterButton className={styles['change-btn']} clickHandler={hideUnhide}>
                    {`Yes, ${action} ${props.isService?'Service':'Product'}`}
                </Modal.CenterButton>
            </Modal>
    );
};

export default withPortal(HideUnhideModal);